
let GetColorOfFieldWidget = function(args, modes) {

    let currentFieldBody = args.annotation ?
        args.annotation.bodies.find(function(b) {
            return b.purpose == 'field';
        }) : null;

    // 2. Keep the value in a variable
    let currentField = currentFieldBody ? currentFieldBody.value : null;

    var currentColorBody = args.annotation ?
        args.annotation.bodies.find(function(b) {
            return b.purpose == 'highlighting';
        }) : null;

    // 2. Keep the value in a variable
    var currentColorValue = currentColorBody ? currentColorBody.value : null;

    // 3. Triggers callbacks on user action
    var addColor = function(color) {
        if (currentColorBody) {
            args.onUpdateBody(currentColorBody, {
                type: 'TextualBody',
                purpose: 'highlighting',
                value: color
            });
        } else {
            args.onAppendBody({
                type: 'TextualBody',
                purpose: 'highlighting',
                value: color
            });
        }
    }

    let container = document.createElement('div')
    container.className = 'p-1 d-flex justify-content-end'
    
    if(currentField){
        const field = modes.fields.find(field => field.id === Number(currentField));
        console.log(field, modes.fields);
        if(field && field.colors.length > 0){
            
            let button = document.createElement('button')
            button.classList = 'btn btn-sm btn-primary'
            button.textContent = 'Usar cor da competência'
            button.onclick = () => {addColor(field.colors[0].color)};

            container.appendChild(button);
        }
    }

    

    
    return container
}

export default GetColorOfFieldWidget;
